import {providers as $9rmgj$providers} from "ethers";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $3f5142117013781a$exports = {};


var $5241bd1eef535dd2$exports = {};

$parcel$export($5241bd1eef535dd2$exports, "Network", () => $5241bd1eef535dd2$export$95be4ae94445245a);
$parcel$export($5241bd1eef535dd2$exports, "CHAIN_LIST", () => $5241bd1eef535dd2$export$53b80692e2bca3d7);
/* eslint-disable unicorn/numeric-separators-style */ let $5241bd1eef535dd2$export$95be4ae94445245a;
(function(Network) {
    Network[Network["POLYGON"] = 137] = "POLYGON";
    Network[Network["BINANCE"] = 56] = "BINANCE";
    Network[Network["ARBITRUM"] = 42161] = "ARBITRUM";
    Network[Network["OPTIMISM"] = 10] = "OPTIMISM";
    Network[Network[// testnets
    "MUMBAI"] = 80001] = "MUMBAI";
    Network[Network["BINANCE_TESTNET"] = 97] = "BINANCE_TESTNET";
    Network[Network["ARBITRUM_GOERLI"] = 421613] = "ARBITRUM_GOERLI";
    Network[Network["OPTIMISM_GOERLI"] = 420] = "OPTIMISM_GOERLI";
})($5241bd1eef535dd2$export$95be4ae94445245a || ($5241bd1eef535dd2$export$95be4ae94445245a = {}));
const $5241bd1eef535dd2$export$53b80692e2bca3d7 = {
    [$5241bd1eef535dd2$export$95be4ae94445245a.POLYGON]: {
        name: "Polygon",
        urls: [
            "https://polygon-rpc.com/"
        ],
        nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://polygonscan.com/"
        ],
        default: true
    },
    [$5241bd1eef535dd2$export$95be4ae94445245a.OPTIMISM]: {
        name: "Optimism",
        urls: [
            "https://mainnet.optimism.io/"
        ],
        nativeCurrency: {
            name: "ETH",
            symbol: "ETH",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://optimistic.etherscan.io/"
        ],
        default: false
    },
    [$5241bd1eef535dd2$export$95be4ae94445245a.BINANCE]: {
        name: "BNB Chain",
        urls: [
            "https://long-red-dust.bsc.quiknode.pro/87599cef97cf19f9a3e1adbd000ede112452e0f4/"
        ],
        nativeCurrency: {
            name: "BNB",
            symbol: "BNB",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://bscscan.com"
        ],
        default: false
    },
    [$5241bd1eef535dd2$export$95be4ae94445245a.ARBITRUM]: {
        name: "Arbitrum",
        urls: [
            "https://arb1.arbitrum.io/rpc/"
        ],
        nativeCurrency: {
            name: "ETH",
            symbol: "ETH",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://arbiscan.io"
        ],
        default: false
    },
    // Testnet
    [$5241bd1eef535dd2$export$95be4ae94445245a.ARBITRUM_GOERLI]: {
        name: "Arbitrum Goerli",
        urls: [
            "https://goerli-rollup.arbitrum.io/rpc/"
        ],
        nativeCurrency: {
            name: "AGOR",
            symbol: "AGOR",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://goerli-rollup-explorer.arbitrum.io"
        ]
    },
    [$5241bd1eef535dd2$export$95be4ae94445245a.MUMBAI]: {
        name: "Mumbai ",
        urls: [
            "https://rpc-mumbai.maticvigil.com/"
        ],
        nativeCurrency: {
            name: "MATIC Testnet",
            symbol: "MATIC",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://polygonscan.com/"
        ],
        default: true
    },
    [$5241bd1eef535dd2$export$95be4ae94445245a.OPTIMISM_GOERLI]: {
        name: "Optimism ",
        urls: [
            "https://goerli.optimism.io"
        ],
        nativeCurrency: {
            name: "ETH",
            symbol: "ETH",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://goerli-explorer.optimism.io"
        ],
        default: false
    },
    [$5241bd1eef535dd2$export$95be4ae94445245a.BINANCE_TESTNET]: {
        name: "BSC Testnet",
        urls: [
            "https://data-seed-prebsc-2-s1.binance.org:8545"
        ],
        nativeCurrency: {
            name: "BNB Testnet",
            symbol: "BNB",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://testnet.bscscan.com"
        ],
        default: false
    }
};


var $6e617ff4c43022c7$exports = {};

$parcel$export($6e617ff4c43022c7$exports, "TokenSymbol", () => $6e617ff4c43022c7$export$a7a55dff594ea775);
let $6e617ff4c43022c7$export$a7a55dff594ea775;
(function(TokenSymbol) {
    TokenSymbol["PORNROCKET"] = "PORNROCKET";
    TokenSymbol["BNB"] = "BNB";
    TokenSymbol["USDC"] = "USDC";
    TokenSymbol["USDT"] = "USDT";
    TokenSymbol["BUSD"] = "BUSD";
    TokenSymbol["MATIC"] = "MATIC";
    TokenSymbol["WMATIC"] = "WMATIC";
    TokenSymbol["WETH"] = "WETH";
    TokenSymbol["WBNB"] = "WBNB";
    TokenSymbol["WBTC"] = "WBTC";
    TokenSymbol["CURVE"] = "CRV";
    TokenSymbol["SUSHI"] = "SUSHI";
    TokenSymbol["DAI"] = "DAI";
    TokenSymbol["OP"] = "OP";
    TokenSymbol["NSFW"] = "NSFW+";
})($6e617ff4c43022c7$export$a7a55dff594ea775 || ($6e617ff4c43022c7$export$a7a55dff594ea775 = {}));


var $4e3120778dcc2687$exports = {};

$parcel$export($4e3120778dcc2687$exports, "mapTokensByChainId", () => $4e3120778dcc2687$export$f76ebbd523167248);


var $e9eff3a3442f6676$exports = {};
$e9eff3a3442f6676$exports = JSON.parse('[{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_account","type":"address"}],"name":"unBlacklist","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"minter","type":"address"}],"name":"removeMinter","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"string"},{"name":"_symbol","type":"string"},{"name":"_currency","type":"string"},{"name":"_decimals","type":"uint8"},{"name":"_masterMinter","type":"address"},{"name":"_pauser","type":"address"},{"name":"_blacklister","type":"address"},{"name":"_owner","type":"address"}],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"masterMinter","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"unpause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_amount","type":"uint256"}],"name":"mint","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_amount","type":"uint256"}],"name":"burn","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"minter","type":"address"},{"name":"minterAllowedAmount","type":"uint256"}],"name":"configureMinter","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_newPauser","type":"address"}],"name":"updatePauser","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"paused","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"account","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"pause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"minter","type":"address"}],"name":"minterAllowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"pauser","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_newMasterMinter","type":"address"}],"name":"updateMasterMinter","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"account","type":"address"}],"name":"isMinter","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_newBlacklister","type":"address"}],"name":"updateBlacklister","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"blacklister","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"owner","type":"address"},{"name":"spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"currency","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_account","type":"address"}],"name":"blacklist","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_account","type":"address"}],"name":"isBlacklisted","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"minter","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"amount","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"burner","type":"address"},{"indexed":false,"name":"amount","type":"uint256"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"minter","type":"address"},{"indexed":false,"name":"minterAllowedAmount","type":"uint256"}],"name":"MinterConfigured","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldMinter","type":"address"}],"name":"MinterRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"newMasterMinter","type":"address"}],"name":"MasterMinterChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_account","type":"address"}],"name":"Blacklisted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_account","type":"address"}],"name":"UnBlacklisted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"newBlacklister","type":"address"}],"name":"BlacklisterChanged","type":"event"},{"anonymous":false,"inputs":[],"name":"Pause","type":"event"},{"anonymous":false,"inputs":[],"name":"Unpause","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"newAddress","type":"address"}],"name":"PauserChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"previousOwner","type":"address"},{"indexed":false,"name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"}]');


const $4e3120778dcc2687$export$f76ebbd523167248 = {
    [(0, $5241bd1eef535dd2$export$95be4ae94445245a).POLYGON]: [
        {
            name: "MATIC",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).MATIC,
            contract: "0xc3a0cc1189D00f63a2933Fa402f6168E854d71e6",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isEnabled: false,
            isNative: true,
            isCanonical: true
        },
        {
            name: "Wrapped MATIC",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).WMATIC,
            contract: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: true
        },
        {
            name: "Wrapped Ether",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).WETH,
            contract: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: true
        },
        {
            name: "SushiToken",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).SUSHI,
            contract: "0x0b3F868E0BE5597D5DB7fEB59E1CADBb0fdDa50a",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: true
        },
        {
            // AA: Verified
            name: "Dai Stablecoin",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).DAI,
            contract: "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: true,
            isCanonical: true
        },
        {
            // AA: Verified
            name: "(PoS) Tether USD",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).USDT,
            contract: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
            decimals: 6,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: true,
            isCanonical: true
        },
        {
            // AA: Verified
            name: "USD Coin (PoS)",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).USDC,
            contract: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
            decimals: 6,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: true,
            isDefault: true,
            isCanonical: true
        },
        {
            name: "Wrapped BTC",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).WBTC,
            contract: "0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6",
            decimals: 8,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: true
        }
    ],
    [(0, $5241bd1eef535dd2$export$95be4ae94445245a).BINANCE]: [
        {
            // AA: Verified
            name: "Binance-Peg USD Coin",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).USDC,
            contract: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: true,
            isDefault: true,
            isCanonical: true
        },
        {
            // AA: Verified
            name: "Binance-Peg BUSD",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).BUSD,
            contract: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: true,
            isCanonical: true
        },
        {
            // AA: Verified
            name: "Binance-Peg BSC-USD (USDT)",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).USDT,
            contract: "0x55d398326f99059fF775485246999027B3197955",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: true,
            isCanonical: true
        },
        {
            name: "Wrapped BNB",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).WBNB,
            contract: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: true
        },
        {
            name: "BNB",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).BNB,
            contract: "TODO",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: true,
            isEnabled: false,
            isCanonical: true
        }
    ],
    [(0, $5241bd1eef535dd2$export$95be4ae94445245a).ARBITRUM]: [
        {
            name: "DAI",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).DAI,
            contract: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: true
        },
        {
            name: "Tether USD",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).USDT,
            contract: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
            decimals: 6,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: true
        },
        {
            name: "USD Coin (Arb1)",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).USDC,
            contract: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
            decimals: 6,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isEnabled: false,
            isNative: false,
            isDefault: true,
            isCanonical: true
        },
        {
            name: "WBTC",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).WBTC,
            contract: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
            decimals: 8,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: true
        },
        {
            name: "Sushi Token",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).SUSHI,
            contract: "0xd4d42F0b6DEF4CE0383636770eF773390d85c61A",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: true
        }
    ],
    [(0, $5241bd1eef535dd2$export$95be4ae94445245a).OPTIMISM]: [
        {
            name: "USD Coin",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).USDC,
            contract: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
            decimals: 6,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: true
        },
        {
            name: "Tether USD",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).USDT,
            contract: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58",
            decimals: 6,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: true
        },
        {
            name: "Dai Stablecoin",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).DAI,
            contract: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: true
        },
        {
            name: "Wrapped BTC",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).WBTC,
            contract: "0x68f180fcCe6836688e9084f035309E29Bf0A2095",
            decimals: 8,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: true
        },
        {
            name: "Optimism",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).OP,
            contract: "0x4200000000000000000000000000000000000042",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isEnabled: false,
            isNative: false,
            isDefault: true,
            isCanonical: true
        }
    ],
    /**
   * Testnets
   * TODO: Update addresses
   */ [(0, $5241bd1eef535dd2$export$95be4ae94445245a).MUMBAI]: [
        {
            // AA: Verified
            // https://mumbai.polygonscan.com/token/0x9c3c9283d3e44854697cd22d3faa240cfb032889
            name: "Wrapped Matic",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).WMATIC,
            contract: "0x9c3c9283d3e44854697cd22d3faa240cfb032889",
            isCanonical: true,
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false
        },
        {
            name: "MATIC",
            contract: "0x0000000000000000000000000000000000001010",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).MATIC,
            isEnabled: false,
            isNative: true,
            isDefault: true,
            isCanonical: true
        },
        // AA: Verified
        // https://mumbai.polygonscan.com/address/0x93e291AD5a36Cc6C91b7C61e7A51b48847970886
        {
            name: "mocked USD Coin",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).USDC,
            contract: "0x93e291AD5a36Cc6C91b7C61e7A51b48847970886",
            decimals: 6,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: true,
            isCanonical: false
        },
        {
            name: "Wrapped BTC",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).WBTC,
            contract: "0x68f180fcCe6836688e9084f035309E29Bf0A2000",
            decimals: 8,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: false
        },
        // AA: Verified
        // https://mumbai.polygonscan.com/address/0x177b24b0B5D2Ab23210c7389d89c8F73007a3D63
        {
            name: "mocked Tether USD",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).USDT,
            contract: "0x177b24b0B5D2Ab23210c7389d89c8F73007a3D63",
            decimals: 6,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: true,
            isCanonical: false
        }
    ],
    [(0, $5241bd1eef535dd2$export$95be4ae94445245a).BINANCE_TESTNET]: [
        {
            // AA: Verified
            // https://testnet.bscscan.com/token/0xFAEe3860f715a0548D79c0ABEE9B16B473915588
            name: "USD Coin",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).USDC,
            contract: "0xFAEe3860f715a0548D79c0ABEE9B16B473915588",
            decimals: 6,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: true,
            isCanonical: false
        },
        {
            // AA: Verified
            // https://testnet.bscscan.com/token/0x401C28fb22EC9cBB8FB979a0b6214d987157F410
            name: "BUSD Token",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).BUSD,
            contract: "0x401C28fb22EC9cBB8FB979a0b6214d987157F410",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: true,
            isDefault: true,
            isCanonical: false
        },
        {
            // AA: Verified
            // https://testnet.bscscan.com/token/0x102EFaA3676Ad49cDeC25A03779eEd0fb5dA88AD
            name: "Tether USD",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).USDT,
            contract: "0x102EFaA3676Ad49cDeC25A03779eEd0fb5dA88AD",
            decimals: 6,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: true,
            isCanonical: false
        },
        {
            name: "Wrapped BNB",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).WBNB,
            contract: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: false
        },
        {
            name: "BNB",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).BNB,
            contract: "TODO",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: true,
            isEnabled: false,
            isCanonical: false
        }
    ],
    [(0, $5241bd1eef535dd2$export$95be4ae94445245a).ARBITRUM_GOERLI]: [
        {
            name: "DAI",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).DAI,
            contract: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
            decimals: 18,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isDefault: true,
            isCanonical: false
        },
        {
            name: "Tether USD",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).USDT,
            contract: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
            decimals: 6,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: false
        }
    ],
    [(0, $5241bd1eef535dd2$export$95be4ae94445245a).OPTIMISM_GOERLI]: [
        {
            name: "USD Coin",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).USDC,
            contract: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
            decimals: 6,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isCanonical: false
        },
        {
            name: "Tether USD",
            symbol: (0, $6e617ff4c43022c7$export$a7a55dff594ea775).USDT,
            contract: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58",
            decimals: 6,
            abi: (0, (/*@__PURE__*/$parcel$interopDefault($e9eff3a3442f6676$exports))),
            isNative: false,
            isEnabled: false,
            isDefault: true,
            isCanonical: false
        }
    ]
};


var $1392bc565735b7c1$exports = {};

$parcel$export($1392bc565735b7c1$exports, "getRpcEndpoint", () => $1392bc565735b7c1$export$1aa941fc132b6f22);

const $1392bc565735b7c1$export$1aa941fc132b6f22 = (chainId)=>{
    switch(chainId){
        case (0, $5241bd1eef535dd2$export$95be4ae94445245a).POLYGON:
            return "https://solitary-ultra-hexagon.matic.quiknode.pro/9a27b5a7bfb3917808b30c6ebd1a58b29fc79e84/";
        case (0, $5241bd1eef535dd2$export$95be4ae94445245a).MUMBAI:
            return "https://spring-yolo-market.matic-testnet.quiknode.pro/f77c72f3ed96a5f852d2ad0d2626f2785f00e6b2/";
        default:
            throw new Error(`No RPC endpoint found for [chainId:${chainId}]`);
    }
};


var $7dc31963c0fdf986$exports = {};

$parcel$export($7dc31963c0fdf986$exports, "getContractAddress", () => $7dc31963c0fdf986$export$b7fbffef12272e40);

const $7dc31963c0fdf986$export$b7fbffef12272e40 = (chainId, token)=>{
    const options = (0, $4e3120778dcc2687$export$f76ebbd523167248)[chainId].find((t)=>t.symbol === token);
    if (!options) throw new Error(`No contract address found for [token:${token}] on [chainId:${chainId}]`);
    return options.contract;
};


var $33c255de0aaeb1d4$exports = {};

$parcel$export($33c255de0aaeb1d4$exports, "getTokenOptions", () => $33c255de0aaeb1d4$export$9b0da8119f9e7209);

const $33c255de0aaeb1d4$export$9b0da8119f9e7209 = (chainId, token)=>{
    const tokens = (0, $4e3120778dcc2687$export$f76ebbd523167248)[chainId];
    const metadata = tokens.find((t)=>t.symbol === token);
    if (!metadata) throw new Error(`Unable to resolve contract metadata for ${token}`);
    return metadata;
};


var $99f3d5c965634d54$exports = {};

$parcel$export($99f3d5c965634d54$exports, "getProviderByChainId", () => $99f3d5c965634d54$export$fb66a1f7f25420fd);


const $99f3d5c965634d54$export$fb66a1f7f25420fd = (chainId)=>{
    switch(chainId){
        case (0, $5241bd1eef535dd2$export$95be4ae94445245a).BINANCE_TESTNET:
            return new (0, $9rmgj$providers).StaticJsonRpcProvider("https://data-seed-prebsc-1-s1.binance.org:8545/");
        case (0, $5241bd1eef535dd2$export$95be4ae94445245a).MUMBAI:
            return new (0, $9rmgj$providers).StaticJsonRpcProvider("https://polygon-mumbai.infura.io/v3/4cc6f96aa4aa478088df021955118618");
        case (0, $5241bd1eef535dd2$export$95be4ae94445245a).POLYGON:
            return new (0, $9rmgj$providers).StaticJsonRpcProvider("https://polygon-mainnet.infura.io/v3/4cc6f96aa4aa478088df021955118618");
        case (0, $5241bd1eef535dd2$export$95be4ae94445245a).BINANCE:
            return new (0, $9rmgj$providers).StaticJsonRpcProvider("https://long-red-dust.bsc.quiknode.pro/87599cef97cf19f9a3e1adbd000ede112452e0f4/");
        case (0, $5241bd1eef535dd2$export$95be4ae94445245a).OPTIMISM:
            return new (0, $9rmgj$providers).StaticJsonRpcProvider("https://optimism-mainnet.infura.io/v3/4cc6f96aa4aa478088df021955118618");
        case (0, $5241bd1eef535dd2$export$95be4ae94445245a).OPTIMISM_GOERLI:
            return new (0, $9rmgj$providers).StaticJsonRpcProvider("https://optimism-goerli.infura.io/v3/4cc6f96aa4aa478088df021955118618");
        case (0, $5241bd1eef535dd2$export$95be4ae94445245a).ARBITRUM:
            return new (0, $9rmgj$providers).StaticJsonRpcProvider("https://arbitrum-mainnet.infura.io/v3/4cc6f96aa4aa478088df021955118618");
        case (0, $5241bd1eef535dd2$export$95be4ae94445245a).ARBITRUM_GOERLI:
            return new (0, $9rmgj$providers).StaticJsonRpcProvider("https://arbitrum-goerli.infura.io/v3/4cc6f96aa4aa478088df021955118618");
        default:
            throw new Error(`Unable to resolve provider for [chainId:${chainId}]`);
    }
};


var $b99edc473215905f$exports = {};

$parcel$export($b99edc473215905f$exports, "getWithdrawalProvider", () => $b99edc473215905f$export$24bf9a54bd65c77d);


const $b99edc473215905f$export$24bf9a54bd65c77d = (chainId)=>{
    switch(chainId){
        case (0, $5241bd1eef535dd2$export$95be4ae94445245a).MUMBAI:
            return new (0, $9rmgj$providers).StaticJsonRpcProvider("https://polygon-mumbai.infura.io/v3/4cc6f96aa4aa478088df021955118618");
        case (0, $5241bd1eef535dd2$export$95be4ae94445245a).POLYGON:
            return new (0, $9rmgj$providers).StaticJsonRpcProvider("https://polygon-mainnet.infura.io/v3/4cc6f96aa4aa478088df021955118618");
        default:
            throw new Error(`Unable to resolve provider for [chainId:${chainId}]`);
    }
};


var $e0f8245d96ee1fcc$exports = {};

$parcel$export($e0f8245d96ee1fcc$exports, "getDefaultToken", () => $e0f8245d96ee1fcc$export$58eb11d37f1d6614);

const $e0f8245d96ee1fcc$export$58eb11d37f1d6614 = (chainId)=>{
    const tokens = (0, $4e3120778dcc2687$export$f76ebbd523167248)[chainId];
    if (!tokens || tokens.length === 0) throw new Error(`No tokens configured for chainId ${chainId}`);
    // find first enabled token, TODO: add isDefault ??
    const token = tokens.find((o)=>o.isEnabled);
    if (!token) throw new Error(`No default token configured for chainId ${chainId}`);
    return token;
};


var $6b99323bf676a3e3$exports = {};

$parcel$export($6b99323bf676a3e3$exports, "resolveDecimalsFromSymbol", () => $6b99323bf676a3e3$export$d1082114bcc33bc2);

const $6b99323bf676a3e3$export$d1082114bcc33bc2 = (chainId, tokenSymbol)=>{
    const decimals = (0, $4e3120778dcc2687$export$f76ebbd523167248)[chainId].find((token)=>token.symbol === tokenSymbol).decimals;
    if (!decimals) throw new Error(`Decimals not found for ${tokenSymbol}`);
    return decimals;
};


var $8a946824ba8a3c82$exports = {};


var $f50e97a911ac86d3$exports = {};

$parcel$export($f50e97a911ac86d3$exports, "isTokenAccepted", () => $f50e97a911ac86d3$export$b4da4a4e68c659f1);

const $f50e97a911ac86d3$export$b4da4a4e68c659f1 = (chainId, token)=>{
    const tokens = (0, $4e3120778dcc2687$export$f76ebbd523167248)[chainId];
    if (tokens.length === 0) return false;
    const tokensAccepted = tokens.map((t)=>t.symbol);
    return tokensAccepted.includes(token);
};


var $60f386be1b02083e$exports = {};

$parcel$export($60f386be1b02083e$exports, "shortAddress", () => $60f386be1b02083e$export$193698062786be9a);
const $60f386be1b02083e$export$193698062786be9a = (address, characters = 37)=>{
    return address ? `${address.slice(0, 5)}...${address.slice(characters)}` : "";
};


var $706d2b15039d7e5f$exports = {};

$parcel$export($706d2b15039d7e5f$exports, "resolveWithdrawalWallet", () => $706d2b15039d7e5f$export$f872d5b3ecde1e8a);
const $706d2b15039d7e5f$export$f872d5b3ecde1e8a = (env)=>{
    switch(true){
        case [
            "dev",
            "test",
            "stage",
            "ci"
        ].includes(env):
            return "alias/stage-nsfw-withdrawal-wallet";
        case [
            "beta"
        ].includes(env):
            return "alias/beta-nsfw-withdrawal-wallet";
        default:
            throw new Error(`define WithdrawalWallet for [${env}]`);
    }
};




export {$5241bd1eef535dd2$export$95be4ae94445245a as Network, $5241bd1eef535dd2$export$53b80692e2bca3d7 as CHAIN_LIST, $6e617ff4c43022c7$export$a7a55dff594ea775 as TokenSymbol, $4e3120778dcc2687$export$f76ebbd523167248 as mapTokensByChainId, $7dc31963c0fdf986$export$b7fbffef12272e40 as getContractAddress, $f50e97a911ac86d3$export$b4da4a4e68c659f1 as isTokenAccepted, $706d2b15039d7e5f$export$f872d5b3ecde1e8a as resolveWithdrawalWallet, $6b99323bf676a3e3$export$d1082114bcc33bc2 as resolveDecimalsFromSymbol, $e0f8245d96ee1fcc$export$58eb11d37f1d6614 as getDefaultToken, $99f3d5c965634d54$export$fb66a1f7f25420fd as getProviderByChainId, $b99edc473215905f$export$24bf9a54bd65c77d as getWithdrawalProvider, $1392bc565735b7c1$export$1aa941fc132b6f22 as getRpcEndpoint, $33c255de0aaeb1d4$export$9b0da8119f9e7209 as getTokenOptions, $60f386be1b02083e$export$193698062786be9a as shortAddress};
//# sourceMappingURL=module.js.map
